import {FASTING_LOCAL_STORAGE_KEY, MODE, WEIGHT_LOSS_LOCAL_STORAGE_KEY} from "../../const/LocalStorage";
import FastingFormData from "./fasting/FastingFormData";
import WeightLossFormData from "./weight-loss/WeightLossFormData";

export const QUESTIONNAIRE_IDS = {
    WEIGHT_LOSS: "weight-loss",
    FASTING: "fasting"
};

export const DEFAULT_QUESTIONNAIRE_ID = QUESTIONNAIRE_IDS.WEIGHT_LOSS;

const DEFAULT_CRITICAL_IMAGE_RELATIVE_PATHS = [
    "gender/GenderFemale20.png",
    "gender/GenderFemale40.png",
    "gender/GenderFemale60.png",
    "gender/GenderFemale80.png",
    "gender/GenderMale20.png",
    "gender/GenderMale40.png",
    "gender/GenderMale60.png",
    "gender/GenderMale80.png",
    "currentBodyType/male_skinny@3x.png",
    "currentBodyType/male_regular@3x.png",
    "currentBodyType/male_extra@3x.png",
    "currentBodyType/female_regular@3x.png",
    "currentBodyType/female_plump@3x.png",
    "currentBodyType/female_extra@3x.png"
];

const buildQuestionnaireAssetPaths = (assetNamespace, relativePaths = DEFAULT_CRITICAL_IMAGE_RELATIVE_PATHS) => {
    if (!assetNamespace) {
        return [];
    }

    return relativePaths.map(path => `/static/image/questionnaire/${assetNamespace}/${path}`);
};

const createQuestionnaireConfig = ({
    id,
    mode,
    localStorageKey,
    surveyRoute,
    payRoute,
    FormDataClass,
    workoutName = id,
    assetNamespace = id,
    criticalImageRelativePaths = DEFAULT_CRITICAL_IMAGE_RELATIVE_PATHS
}) => {
    return {
        id,
        workoutName,
        mode,
        criticalImagePaths: buildQuestionnaireAssetPaths(assetNamespace, criticalImageRelativePaths),
        localStorageKey,
        surveyRoute,
        payRoute,
        FormDataClass
    };
};

export const QUESTIONNAIRE_REGISTRY = {
    [QUESTIONNAIRE_IDS.WEIGHT_LOSS]: createQuestionnaireConfig({
        id: QUESTIONNAIRE_IDS.WEIGHT_LOSS,
        mode: "weightloss",
        localStorageKey: WEIGHT_LOSS_LOCAL_STORAGE_KEY,
        surveyRoute: "/survey/weight-loss",
        payRoute: "/survey/weight-loss/pay",
        FormDataClass: WeightLossFormData
    }),
    [QUESTIONNAIRE_IDS.FASTING]: createQuestionnaireConfig({
        id: QUESTIONNAIRE_IDS.FASTING,
        mode: "fasting",
        localStorageKey: FASTING_LOCAL_STORAGE_KEY,
        surveyRoute: "/survey/fasting",
        payRoute: "/survey/fasting/pay",
        FormDataClass: FastingFormData
    })
};

const questionnaireConfigs = Object.values(QUESTIONNAIRE_REGISTRY);

export const getQuestionnaireConfigById = (questionnaireId = DEFAULT_QUESTIONNAIRE_ID) => {
    return QUESTIONNAIRE_REGISTRY[questionnaireId] || QUESTIONNAIRE_REGISTRY[DEFAULT_QUESTIONNAIRE_ID];
};

export const getQuestionnaireConfigByWorkoutName = (workoutName) => {
    return questionnaireConfigs.find(config => config.workoutName === workoutName) || getQuestionnaireConfigById();
};

export const getQuestionnaireConfigByMode = (mode) => {
    return questionnaireConfigs.find(config => config.mode === mode) || getQuestionnaireConfigById();
};

export const createQuestionnaireFormData = (questionnaireIdOrConfig = DEFAULT_QUESTIONNAIRE_ID) => {
    const config = typeof questionnaireIdOrConfig === "string"
        ? getQuestionnaireConfigById(questionnaireIdOrConfig)
        : questionnaireIdOrConfig;
    return new config.FormDataClass();
};

export const restoreQuestionnaireFormData = (questionnaireIdOrConfig, data) => {
    return createQuestionnaireFormData(questionnaireIdOrConfig).fromPlainObject(data);
};

export const getCurrentQuestionnaireConfig = () => {
    const currentMode = localStorage.getItem(MODE);
    if (currentMode) {
        const currentConfig = getQuestionnaireConfigByMode(currentMode);
        if (localStorage.getItem(currentConfig.localStorageKey)) {
            return currentConfig;
        }
    }

    const configFromStorage = questionnaireConfigs.find(config => localStorage.getItem(config.localStorageKey));
    return configFromStorage || getQuestionnaireConfigById();
};

export default QUESTIONNAIRE_REGISTRY;
